import React, {useEffect, useState} from "react";
import {Button, ButtonGroup, Divider, Input, Select, SelectItem} from "@nextui-org/react";
import {FaEnvelope, FaPlusCircle, FaPhoneAlt, FaUserAlt, FaLock} from 'react-icons/fa';
import {useLocation, useNavigate} from "react-router-dom";
import {getMachines, getProducts, SaveStock, getDeposits} from "../API";
import Cookies from "universal-cookie";


export default function StockDetails() {
    const [stock, setStock] = useState({
        new: true,
        code: null,
        amount: 0
    });
    const [isLoading, setIsLoading] = useState(false);
    const [products, setProducts] = useState([]);
    const [deposits, setDeposits] = React.useState([]);
    const location = useLocation();
    const {data, machine} = location.state || {};
    const navigate = useNavigate();

    useEffect(
        () => {
            Starting();
        }, []
    )

    async function Starting() {
        const p = await getProducts();
        const d = await getDeposits();
        setDeposits(d);
        setProducts(p);

        const cookie = new Cookies();
        const iduser = cookie.get('userdata').iduser;
        setStock({...stock, iduser: iduser});
    }


    function OnChange(e) {
        setStock({...stock, [e.target.name]: e.target.value});
    }

    const findKeyByValue = (object, value) => {
        return Object.keys(object).find(key => object[key] === value);
    };

    async function Save(e){
        e.preventDefault();
        setIsLoading(true);

        const res = await SaveStock(stock);
        navigate("/dashboard/stock-list");
        setIsLoading(false);
    }

    return (
        <>
            <h1 className="pb-5 text-2xl"><b
                className='text-warning'>{stock.idstock === undefined ? "Nuevo item de stock" : `Posicion: ${stock.code}`}</b></h1>

            <div className=" flex flex-col gap-4">
                <form className="flex w-full flex-wrap gap-4" onSubmit={Save}>

                    <h2 className="text-xl text-warning">Datos del producto</h2>
                    <Select
                        labelPlacement="outside"
                        label="Productos"
                        isRequired
                        required
                        name="idproduct"
                        onChange={OnChange}
                        items={products}>
                        {
                            (items) => (<SelectItem key={'' + items.idproduct}>{items.name}</SelectItem>)
                        }
                    </Select>
                    <Input
                        type="text"
                        label="Codigo"
                        labelPlacement="outside"
                        value={stock.code}
                        onChange={OnChange}
                        name="code"
                    />
                    <Input
                        type="number"
                        label="Cantidad"
                        labelPlacement="outside"
                        value={stock.amount}
                        onChange={OnChange}
                        name="amount"
                        min={1}
                        isRequired
                        required
                    />
                    <Select
                        labelPlacement="outside"
                        label="Deposito"
                        isRequired
                        required
                        name="iddeposit"
                        onChange={OnChange}
                        items={deposits}>
                        {
                            (items) => (<SelectItem key={'' + items.iddeposit}>{items.deposit_name}</SelectItem>)
                        }
                    </Select>


                    <div className="container text-center">
                        <Button color="success" type="submit"
                                size="lg" isLoading={isLoading}>Crear</Button>

                    </div>

                </form>

            </div>
        </>
    );
}
